import { PanelLeft } from "lucide-react";
import { useTranslate } from "ra-core";
import { useMemo } from "react";
import { Link } from "react-router";

import { useConfigurationContext } from "../root/ConfigurationContext";
import { useDeskShell } from "./desk/DeskShellContext";
import { DeskNav } from "./desk/DeskNav";
import { ICON_STROKE } from "./desk/navHelpers";
import { DeskSidebarFooter } from "./desk/DeskSidebarFooter";
import { buildDeskNav } from "./desk/navConfig";
import { useMyTasks } from "./desk/useShellData";

/**
 * Desktop sidebar. It is the app background (no card): brand + collapse
 * button, the navigation (scrolls when taller than the viewport), then the
 * bottom block pinned to the foot (status card, utilities, user card).
 */
export const AppSidebar = () => {
  const translate = useTranslate();
  const { collapsed, toggle } = useDeskShell();
  const {
    darkModeLogo,
    lightModeLogo,
    title,
    noteStatuses,
    dealStages,
    dealPipelineStatuses,
  } = useConfigurationContext();
  const items = useMemo(
    () => buildDeskNav({ noteStatuses, dealStages, dealPipelineStatuses }),
    [noteStatuses, dealStages, dealPipelineStatuses],
  );
  const { overdue, dueToday } = useMyTasks();
  const toggleLabel = translate(
    collapsed ? "desk.shell.expand" : "desk.shell.collapse",
  );

  return (
    <aside
      className="desk-sidebar"
      data-collapsed={collapsed ? "true" : undefined}
    >
      <div className="desk-sidebar__brand">
        <Link to="/" className="desk-sidebar__logo" aria-label={title}>
          <img className="[.light_&]:hidden" src={darkModeLogo} alt="" />
          <img className="[.dark_&]:hidden" src={lightModeLogo} alt="" />
          <span className="desk-sidebar__title">{title}</span>
        </Link>
        <button
          type="button"
          className="desk-sidebar__toggle desk-press"
          onClick={toggle}
          aria-label={toggleLabel}
          title={`${toggleLabel} (Ctrl B)`}
          aria-keyshortcuts="Control+B Meta+B"
        >
          <PanelLeft aria-hidden className="size-4" strokeWidth={ICON_STROKE} />
        </button>
      </div>
      <div className="desk-sidebar__scroll">
        <DeskNav
          items={items}
          collapsed={collapsed}
          badges={{ tasks: overdue + dueToday }}
        />
      </div>
      <DeskSidebarFooter collapsed={collapsed} />
    </aside>
  );
};
